module.exports = __webpack_public_path__ + "uploadSample.51858e43cdff030d015b9a53714030da.svg";